import useClickOutside from 'Components/GMS/CustomHooks/useClickOutside';
import { MenuDownIcon } from 'assests/GmsIcons';
import React from 'react';

type optionType = {
    name: string,
    onClick: Function
}

type propType = {
    options:optionType[],
    name: string,
    disabled?: boolean
}

const ButtonDropDown = (props:propType) => {
  const { showMenu, ref, handleClick } = useClickOutside();

  return (
    <React.Fragment>   
      <div className='tw-flex'>
        <div ref={ref} className='tw-relative tw-bg-white'>      
          <button  onClick={props?.disabled ? ()=>{}: handleClick} className={`${showMenu ? 'tw-bg-[#EBECF0] tw-border' : ''} ${props?.disabled ? "hover:tw-cursor-not-allowed":"hover:tw-bg-[#EBECF0]"}  tw-border tw-p-2 tw-rounded-[4px] tw-flex flex-row tw-items-center tw-justify-center tw-gap-[6px]`}>
            <button disabled={props?.disabled} className={`tw-text-sm tw-font-normal tw-w-[100%]  tw-text-[#172B4D]`}>
              <span className='tw-mt-2 tw-font-semibold tw-text-black'>{props?.name}</span>
            </button>
            <MenuDownIcon/>
          </button>
          {showMenu && <div className={`tw-origin-top-right tw-absolute tw-mt-1 tw-w-max tw-mx-3 tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
            <div className={`tw-py-1 tw-text-left`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
              {props?.options?.map((option:optionType) => (
                <React.Fragment key={option?.name} >
                  <div onClick={() => {option?.onClick(); handleClick()}}  className={`tw-flex tw-justify-between tw-items-center tw-py-1 tw-px-2 hover:tw-bg-[#EBECF0]`}>
                    <div className={`tw-flex tw-items-center `}>
                      <label className={`tw-ms-2 tw-text-[#091E42 tw-text-sm]`}>{option?.name}</label>
                    </div>
                  </div>
                </React.Fragment>  
              ))} 
            </div> 
          </div>} 
        </div>
      </div>
  </React.Fragment>
  )
}

export default ButtonDropDown
